import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { CompanyHelper } from "src/app/main/helpers";

@Component({
  selector: "app-guanabara-footer",
  templateUrl: "./guanabara-footer.component.html",
  encapsulation: ViewEncapsulation.None,
})
export class GuanabaraFooterComponent implements OnInit {
  public showFooterLinks: boolean = true;

  constructor(
    public companyHelper: CompanyHelper,
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) {
    this.activatedRoute.queryParams.subscribe(() => {
      let currUrl = window.location.pathname;
      if (currUrl.includes("checkout") || this.router.url.includes("checkout"))
        this.showFooterLinks = false;
      else this.showFooterLinks = true;
    });
  }

  ngOnInit() {}
}
